export default {
  de: {
    title: 'Mandate',
    absolute: 'Absolute Mehrheit',
    noAbsolute: '-',
    mandatesTotal: 'Gesamtmandate',
    mandates: 'Mandate',
    party: 'Partei',
    noCouncilParties: 'Mandate unbekannt',
  },
};
